// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"18c0ce1b","145":"a87ea0cd","248":"ba0ac16d","540":"131ad21e","737":"be0b989b","740":"746e5042","787":"ad5223f9","878":"74bc54fe"}[chunkId] + ".chunk.js";
};